import React, { FC, useState } from 'react';
import { CardImage, LandscapeImageContainer, MoviePortraitImage, MoviePortraitImageWrapper } from 'style/styled-components/reusable.css';
import fallbackLandscape from 'assets/images/landscape_fallback.png';

import { ServiceOptionCover } from 'types/Cover';
import fallbackPortrait from 'assets/images/portrait_fallback.png';
import { getCurrencySymbol } from 'utils/fnData';
import {
    CardLandscapeWrapper,
    CardWrapper,
    ImageWrapper,
    InfoWrapper,
    PricingWrapper,
    SubscriptionType,
    Title,
    SubscriptionPricing,
    PriceValue,
    CurrencyAndDuration,
    MarkerLabel,
} from './CardSubscription.css';

export const CardService: FC<{ asset: ServiceOptionCover }> = ({ asset }) => {
    const { title, price, currency, image, optionTypeLabel, duration, onClick, type, markerLabel } = asset;

    const [portraitImageError, setPortraitImageError] = useState<boolean>(false);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
        }
    };

    return (
        <CardWrapper onClick={onClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
            <CardLandscapeWrapper>
                <ImageWrapper>
                    <LandscapeImageContainer>
                        <CardImage url={image} fallbackImage={fallbackLandscape} />
                    </LandscapeImageContainer>
                    {image && type === 'MOVIE' && !portraitImageError && (
                        <MoviePortraitImageWrapper>
                            <MoviePortraitImage>
                                <CardImage
                                    url={image}
                                    fallbackImage={fallbackPortrait}
                                    {...{
                                        imageError: () => {
                                            setPortraitImageError(true);
                                        },
                                    }}
                                />
                            </MoviePortraitImage>
                        </MoviePortraitImageWrapper>
                    )}
                    {markerLabel && <MarkerLabel>{markerLabel}</MarkerLabel>}
                </ImageWrapper>
                <InfoWrapper>
                    <Title>{title}</Title>
                    <SubscriptionType>{optionTypeLabel}</SubscriptionType>
                    <PricingWrapper>
                        <SubscriptionPricing>
                            <PriceValue>
                                {price} {getCurrencySymbol(currency)}{' '}
                            </PriceValue>
                            <CurrencyAndDuration>{duration ? `${duration}` : ''}</CurrencyAndDuration>
                        </SubscriptionPricing>
                    </PricingWrapper>
                </InfoWrapper>
            </CardLandscapeWrapper>
        </CardWrapper>
    );
};
